const emptyData = [
  {
    "type": "M01",
    "value": 0,
    "series": "inclusiveEconomicDevelopment",
  },
  {
    "type": "M02",
    "value": 0,
    "series": "inclusiveEconomicDevelopment",
  },
  {
    "type": "M03",
    "value": 0,
    "series": "inclusiveEconomicDevelopment",
  },
  {
    "type": "M04",
    "value": 472,
    "series": "inclusiveEconomicDevelopment",
  },
  {
    "type": "M05",
    "value": 476,
    "series": "inclusiveEconomicDevelopment",
  },
  {
    "type": "M06",
    "value": 483,
    "series": "inclusiveEconomicDevelopment",
  },
  {
    "type": "M07",
    "value": 491,
    "series": "inclusiveEconomicDevelopment",
  },
  {
    "type": "M08",
    "value": 499,
    "series": "inclusiveEconomicDevelopment",
  },
  {
    "type": "M09",
    "value": 500,
    "series": "inclusiveEconomicDevelopment",
  },
  {
    "type": "M10",
    "value": 500,
    "series": "inclusiveEconomicDevelopment",
  },
  {
    "type": "M11",
    "value": 500,
    "series": "inclusiveEconomicDevelopment",
  },
  {
    "type": "M12",
    "value": 500,
    "series": "inclusiveEconomicDevelopment",
  },
  {
    "type": "M01",
    "value": 30,
    "series": "environmentalProtection",
    "realValue": 30
  },
  {
    "type": "M02",
    "value": 147,
    "series": "environmentalProtection",
    "realValue": 117
  },
  {
    "type": "M03",
    "value": 165,
    "series": "environmentalProtection",
    "realValue": 18
  },
  {
    "type": "M04",
    "value": 183,
    "series": "environmentalProtection",
    "realValue": 18
  },
  {
    "type": "M05",
    "value": 185,
    "series": "environmentalProtection",
    "realValue": 2
  },
  {
    "type": "M06",
    "value": 191,
    "series": "environmentalProtection",
    "realValue": 6
  },
  {
    "type": "M07",
    "value": 191,
    "series": "environmentalProtection",
    "realValue": 0
  },
  {
    "type": "M08",
    "value": 195,
    "series": "environmentalProtection",
    "realValue": 4
  },
  {
    "type": "M09",
    "value": 195,
    "series": "environmentalProtection",
    "realValue": 0
  },
  {
    "type": "M10",
    "value": 195,
    "series": "environmentalProtection",
    "realValue": 0
  },
  {
    "type": "M11",
    "value": 196,
    "series": "environmentalProtection",
    "realValue": 1
  },
  {
    "type": "M12",
    "value": 196,
    "series": "environmentalProtection",
    "realValue": 0
  },
  {
    "type": "M01",
    "value": 23,
    "series": "safeAndDignifiedWorkingConditions",
    "realValue": 23
  },
  {
    "type": "M02",
    "value": 123,
    "series": "safeAndDignifiedWorkingConditions",
    "realValue": 100
  },
  {
    "type": "M03",
    "value": 147,
    "series": "safeAndDignifiedWorkingConditions",
    "realValue": 24
  },
  {
    "type": "M04",
    "value": 196,
    "series": "safeAndDignifiedWorkingConditions",
    "realValue": 49
  },
  {
    "type": "M05",
    "value": 204,
    "series": "safeAndDignifiedWorkingConditions",
    "realValue": 8
  },
  {
    "type": "M06",
    "value": 227,
    "series": "safeAndDignifiedWorkingConditions",
    "realValue": 23
  },
  {
    "type": "M07",
    "value": 262,
    "series": "safeAndDignifiedWorkingConditions",
    "realValue": 35
  },
  {
    "type": "M08",
    "value": 288,
    "series": "safeAndDignifiedWorkingConditions",
    "realValue": 26
  },
  {
    "type": "M09",
    "value": 298,
    "series": "safeAndDignifiedWorkingConditions",
    "realValue": 10
  },
  {
    "type": "M10",
    "value": 308,
    "series": "safeAndDignifiedWorkingConditions",
    "realValue": 10
  },
  {
    "type": "M11",
    "value": 308,
    "series": "safeAndDignifiedWorkingConditions",
    "realValue": 0
  },
  {
    "type": "M12",
    "value": 308,
    "series": "safeAndDignifiedWorkingConditions",
    "realValue": 0
  },
  {
    "type": "M01",
    "value": 23,
    "series": "goodGovernance",
    "realValue": 23
  },
  {
    "type": "M02",
    "value": 123,
    "series": "goodGovernance",
    "realValue": 100
  },
  {
    "type": "M03",
    "value": 147,
    "series": "goodGovernance",
    "realValue": 24
  },
  {
    "type": "M04",
    "value": 196,
    "series": "goodGovernance",
    "realValue": 49
  },
  {
    "type": "M05",
    "value": 204,
    "series": "goodGovernance",
    "realValue": 8
  },
  {
    "type": "M06",
    "value": 227,
    "series": "goodGovernance",
    "realValue": 23
  },
  {
    "type": "M07",
    "value": 262,
    "series": "goodGovernance",
    "realValue": 35
  },
  {
    "type": "M08",
    "value": 288,
    "series": "goodGovernance",
    "realValue": 26
  },
  {
    "type": "M09",
    "value": 298,
    "series": "goodGovernance",
    "realValue": 10
  },
  {
    "type": "M10",
    "value": 308,
    "series": "goodGovernance",
    "realValue": 10
  },
  {
    "type": "M11",
    "value": 308,
    "series": "goodGovernance",
    "realValue": 0
  },
  {
    "type": "M12",
    "value": 308,
    "series": "goodGovernance",
    "realValue": 0
  }
].map((v) => ({ ...v, value: 0, realValue: 0 }));

export default emptyData
